import {observer} from 'mobx-react';
import {QuickTip, ContactUsLink} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {calendarDate} from 'shared/tools';

const HelpArticleLink = () => {
  return (
    <a target='_blank' href='http://support.collage.co/time-off/updating-a-time-off-policy' rel='noreferrer'>
      <FormattedMessage id='time_off.policy.edit.confirmation.Read more'/>
    </a>
  );
};

const Explanation = observer(({uiState, effectiveDateType}) => {
  const {confirmationSummary, effectiveDate} = uiState;
  const date = <span className='medium'>{calendarDate(effectiveDate)}</span>;

  if (confirmationSummary && confirmationSummary.accrualStart === 'policy_holder_start_date') {
    let paragraphs = [
      // eslint-disable-next-line react/jsx-key
      <FormattedMessage id='time_off.policy.edit.confirmation.POLICY_HOLDER_START_DATE_EXPLANATION_2' values={{contactUs: <ContactUsLink/>}}/>
    ];
    if (confirmationSummary.accrualFrequency === 'annual') {
      paragraphs = [
        // eslint-disable-next-line react/jsx-key
        <FormattedMessage id='time_off.policy.edit.confirmation.POLICY_HOLDER_START_DATE_EXPLANATION_1'/>,
        ...paragraphs
      ];
    }
    return (
      <QuickTip
        header={<FormattedMessage id='time_off.policy.edit.confirmation.POLICY_HOLDER_START_DATE_HEADER'/>}
        trait='caution'
        paragraphs={paragraphs}
      />
    );
  }

  if (effectiveDateType === 'startOfPolicyYear') {
    return (
      <QuickTip
        header={<FormattedMessage id='time_off.policy.edit.confirmation.POLICY_START_DATE_HEADER' values={{date}}/>}
        trait='caution'
        paragraphs={[
          // eslint-disable-next-line react/jsx-key
          <FormattedMessage id='time_off.policy.edit.confirmation.POLICY_START_DATE_EXPLANATION_1'/>,
          // eslint-disable-next-line react/jsx-key
          <ul className='pl2'>
            <li><FormattedMessage id='time_off.policy.edit.confirmation.POLICY_START_DATE_EXPLANATION_2' values={{date}}/></li>
            <li><FormattedMessage id='time_off.policy.edit.confirmation.POLICY_START_DATE_EXPLANATION_3' values={{date}}/></li>
            <li><FormattedMessage id='time_off.policy.edit.confirmation.POLICY_START_DATE_EXPLANATION_4' values={{date}}/></li>
            <li><FormattedMessage id='time_off.policy.edit.confirmation.POLICY_START_DATE_EXPLANATION_5' values={{
              date,
              link: <HelpArticleLink/>
            }}/></li>
          </ul>
        ]}
      />
    );
  }
});

export default Explanation;
